export const siteAuditCSS = {
  headingLabel: {
    fontWeight: 900,
    fontSize: 'var(--font-size-18)',
    fontFamily: 'Inter',
    color: 'var(--color-text-heading)'
  },
  siteDropDown: {
    backgroundColor: 'rgba(244, 244, 244, 1)',
    borderRadius: '8px 8px 0px 0px',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'var(--color-text-heading)',
    height: '38px',
    width: { xs: '3rem', ns: '5rem', sm: '17rem' },
    padding: '10px'
  },
  dropDownItemFont: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    paddingLeft: '2px',
    lineHeight: 'var(--line-height-18)',
    color: 'var(--color-text-heading)'
  },
  dropDownItemImage: {
    width: '20px',
    height: '20px',
    margin: '0px 6px 4px 8px',
    display: 'inline-grid',
    top: '4px'
  }
};

export const fifthCardCss = {
  card: {
    marginTop: '1rem',
    width: 'Hug (1,140px)',
    height: 'Hug (529.87px)',
    gap: '16px',
    backgroundColor: 'var(--color-white)',
    boxShadow: '0px 0px 12px 2px rgba(0,0,0,0.06)',
    padding: '24px',
    borderRadius: '8px',
    marginBottom: '1rem'
  },
  cardContent: {
    padding: 0
  },
  tableRow: {
    '& .MuiTableCell-root': {
      borderBottom: 'none',
      borderTop: 'none',
      backgroundColor: 'rgb(250,250,250)'
    }
  },
  textField: {
    width: {
      xs: 200,
      sm: 200,
      md: '18rem',
      lg: '18rem'
    },
    border: '1px solid var(--color-border)',
    backgroundColor: 'var(--color-white)',
    borderRadius: '8px',
    height: '44px',
    padding: '10px'
  },
  tablePagination: {
    display: 'flex',
    justifyContent: 'end'
  },
  rowTooltipText: {
    fontSize: '11px'
  }
};

export const fifthCardCssPdf = {
  card: {
    marginTop: '25px',
    width: 'Hug (1,140px)',
    height: 'Hug (529.87px)',
    padding: '24px',
    borderRadius: '12px',
    gap: '16px',
    backgroundColor: 'var(--color-white)'
  },
  cardContent: {
    padding: 0
  },
  tableRow: {
    '& .MuiTableCell-root': {
      borderBottom: 'none',
      borderTop: 'none'
    }
  },
  textField: {
    width: {
      xs: 200,
      sm: 200,
      md: '18rem',
      lg: '18rem'
    },
    border: 'none',
    backgroundColor: 'rgba(244, 244, 244, 1)',
    borderRadius: '8px',
    height: '38px',
    padding: '10px'
  },
  tablePagination: {
    display: 'flex',
    justifyContent: 'center'
  }
};

export const firstCardCss = {
  stackSx: {
    display: 'block',
    textAlign: 'center',
    position: 'relative',
    zIndex: 0,
    width: {
      xs: '100%',
      sm: '100%',
      md: '100%',
      lg: '100%',
      xl: '100%',
      '@media (min-width: 1820px)': {
        width: '80%' // Apply this width for screens larger than 2500px
      },
      '@media (min-width: 2000px)': {
        width: '60%' // Apply this width for screens larger than 2500px
      },
      '@media (min-width: 2500px)': {
        width: '50%' // Apply this width for screens larger than 2500px
      },
      '@media (min-width: 3200px)': {
        width: '35%' // Apply this width for screens larger than 2500px
      },
      '@media (min-width: 4100px)': {
        width: '20%' // Apply this width for screens larger than 2500px
      }
    },
    maxWidth: '100%'
  },
  firstBox: {
    top: '25%',
    display: 'flow',
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center'
  },
  theAverageSeoScore: {
    fontWeight: { xs: '800 !important', sm: '400 !important' },
    fontSize: {
      xs: '0.475rem',
      sm: '12px'
    },
    color: 'var(--color-black)',
    fontFamily: 'Inter',
    lineHeight: {
      xs: '1rem',
      sm: '14px'
    },
    marginTop: '1rem'
  },
  percentage: {
    fontFamily: 'Inter',
    fontWeight: 800,
    lineHeight: '56px',
    fontSize: { xs: '0.475', sm: '2.25rem' },
    color: 'rgba(55, 63, 65, 1)',
    marginTop: {
      xs: '',
      sm: '1.25rem',
      md: '1.25rem',
      lg: '1.25rem',
      xl: '1.25rem'
    }
  },
  increasedByButton: {
    width: { xs: '50%', sm: '9rem' },
    fontWeight: 700,
    fontSize: { xs: '0.65rem', sm: '0.75rem' },
    color: 'var(--color-white)',
    fontFamily: 'Inter',
    borderRadius: '4px',
    height: { xs: '0.1rem', sm: '2.25rem' },
    gap: '1vw',
    backgroundColor: 'var(--color-secondary)',
    marginTop: '10px'
  },
  websiteauditReAuditButton: {
    width: '64%',
    borderRadius: '4px',
    border: '1px solid',
    gap: '1vw',
    marginTop: {
      md: '2.6rem',
      tg: '0rem'
    }
  },
  healthScoreDescription: {
    fontFamily: 'Inter',
    fontWeight: '400 !important',
    lineHeight: 'var(--line-height-18)',
    letterSpacing: '0.20000000298023224px',
    color: 'var(--color-black)',
    marginBottom: 'revert',
    marginTop: '8px'
  },
  paperStyle: {
    width: { xs: '59%', ns: '43%', sm: '35%' },
    fontWeight: 700,
    fontSize: '70%',
    color: 'var(--color-white)',
    fontFamily: 'Inter',
    borderRadius: '4px',
    height: '2.25rem',
    gap: '1vw',
    marginTop: { xs: '-6%', ns: '10px' },
    padding: '0', // Remove default padding
    display: 'flex', // Add display flex to center the text
    alignItems: 'center', // Vertically center text
    justifyContent: 'center', // Horizontally center text
    marginLeft: 'auto',
    marginRight: 'auto',
    minWidth: '4rem',
    boxShadow: 'none'
  }
};

export const firstCardCssPdf = {
  stackSx: {
    display: 'block',
    textAlign: 'center',
    position: 'relative',
    zIndex: 0,
    width: '36rem', // Fixed width for PDF
    minWidth: '36rem' // Fixed minimum width for PDF
  },
  firstBox: {
    top: '25%',
    display: 'flow',
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute', // Change this line
    alignItems: 'center',
    justifyContent: 'center'
  },
  theAverageSeoScore: {
    fontWeight: '800 !important',
    fontSize: '0.875rem', // Fixed font size
    fontFamily: 'Inter',
    color: 'darkslategray',
    lineHeight: '1.5rem' // Fixed line height
  },
  percentage: {
    fontWeight: 700,
    fontSize: '2.25rem', // Fixed font size
    color: 'rgba(55, 63, 65, 1)',
    fontFamily: 'Inter',
    marginTop: '1.25rem' // Fixed margin top
  },
  increasedByButton: {
    width: '9rem', // Fixed width
    fontWeight: 700,
    fontSize: '0.75rem', // Fixed font size
    color: 'var(--color-white)',
    fontFamily: 'Inter',
    borderRadius: '4px',
    height: '2.25rem', // Fixed height
    gap: '1vw',
    backgroundColor: 'var(--color-secondary)',
    marginTop: '10px'
  },
  websiteauditReAuditButton: {
    width: '64%',
    borderRadius: '4px',
    border: '1px solid',
    gap: '1vw',
    marginTop: '5%' // Fixed margin top for xl
  },
  healthScoreDescription: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: '400 !important',
    lineHeight: 'var(--line-height-22)',
    letterSpacing: '0.20000000298023224px',
    color: 'var(--color-black)',
    marginBottom: 'revert'
  }
};

export const fourthCardCss = {
  mainBox: {
    marginTop: '1rem',
    width: 'Fixed (1,140px)',
    height: 'Hug (623px)',
    gap: '16px',
    backgroundColor: 'var(--color-white)',
    boxShadow: '0px 0px 12px 2px rgba(0,0,0,0.06)',
    padding: '24px',
    borderRadius: '8px'
  },
  titleSx: {
    // fontFamily: 'RalewaySemi',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: '1.5rem',
    letterSpacing: '0em',
    color: 'rgba(55, 63, 65, 1)',
    marginLeft: '0.625rem',
    cursor: 'pointer',
    zIndex: 100000000
  },
  valueSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 800,
    lineHeight: '0px',
    letterSpacing: '0.20000000298023224px',
    color: 'var(--color-text-muted)',
    display: 'contents'
  }
};

export const monitoringAuditModal = {
  monitoringSettingSx: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 0,
    fontSize: 'var(--font-size-16)',
    color: 'black',
    lineHeight: '1.5'
  },
  monitoringDescription: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: '400 !important',
    lineHeight: 'var(--line-height-22)',
    letterSpacing: '0.20000000298023224px',
    textAlign: 'left'
  },
  selectSx: {
    backgroundColor: 'rgba(244, 244, 244, 1)',
    borderRadius: '8px',
    fontFamily: 'Inter',
    fontSize: 'sm:text-lg lg:text-xl',
    fontWeight: 600,
    lineHeight: 'sm:text-lg lg:text-xl',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'var(--color-text-heading)',
    '&:before': {
      borderBottom: 'none'
    },
    '& .MuiSelect-icon': {
      color: 'var(--color-text-heading)'
    }
  },
  deleteAudit: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '500 !important',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center'
  },
  frequencyText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)'
  },
  emailLoaderBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: '70px'
  }
};

export const secondCardCss = {
  mainBoxSx: {
    borderRadius: 1,
    backgroundColor: 'var(--color-white)',
    position: 'relative'
  },
  nameSx: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 'var(--line-height-18)',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'var(--color-text-heading)'
  },
  valueSx: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 'var(--line-height-18)',
    letterSpacing: '0em',
    textAlign: 'right',
    color: 'var(--color-text-heading)'
  }
};

export const secondCardNoGscCss = {
  googleSearchConsoleSx: {
    width: '100%',
    height: '48px',
    borderRadius: '5px',
    gap: '4px',
    marginTop: '3%'
  }
};

export const thirdCardCss = {
  mainBoxSx: {
    borderRadius: 1,
    backgroundColor: 'var(--color-white)',
    position: 'relative',
    height: { xs: '100%', xl: '15.7rem' }
  },
  keywordSx: {
    width: '100%',
    maxWidth: '62px',
    height: '56px',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-36)',
    fontWeight: 800,
    lineHeight: '56px',
    letterSpacing: '0.20000000298023224px',
    color: 'rgba(55, 63, 65, 1)'
  },
  percentage: {
    width: '100%',
    maxWidth: '41px',
    height: '19px',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: '19px',
    letterSpacing: '0em',
    textAlign: 'left'
  },
  chartSx: {
    '.MuiLineElement-root': {
      stroke: 'var(--color-secondary)',
      strokeWidth: 2
    },
    '.MuiMarkElement-root': {
      stroke: 'var(--color-secondary)',
      scale: '0.6',
      fill: 'var(--color-white)',
      strokeWidth: 2
    }
  }
};

export const thirdCardNoGscCss = {
  mainBoxSx: {
    borderRadius: 1,
    backgroundColor: 'var(--color-white)',
    position: 'relative'
  },
  googleSearchConsole: {
    width: '100%',
    height: '48px',
    borderRadius: '5px',
    gap: '4px',
    marginTop: '3%'
  }
};

export const websiteAuditAfterLinearBar = {
  screenSearchDesktopIconCss: {
    color: 'white',
    width: '20px',
    height: '20px',
    marginRight: '-8px'
  },
  setUpMonitoring: {
    padding: '8px 15px',
    borderRadius: '4px',
    gap: '8px',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-22)',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'rgba(252, 252, 252, 1)'
  },
  AddIconSx: {
    width: '20px',
    height: '20px',
    color: 'var(--color-primary)',
    marginRight: '8px'
  },
  scanWebpageSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    color: 'var(--color-text-heading)',
    textAlign: 'left'
  },
  cancelTransferSitesSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: '700 !important',
    textAlign: 'left',
    color: 'var(--color-error-alt)'
  },
  deleteForeverIconSx: {
    width: '20px',
    height: '20px',
    color: 'var(--color-error-alt)',
    marginRight: '8px'
  },
  deleteAudit: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: '700 !important',
    textAlign: 'left',
    color: 'var(--color-error-alt)'
  },
  websiteMonitoring: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '500 !important',
    lineHeight: '1.2',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'var(--color-text-grey-purple)',
    marginLeft: '10px'
  }
};

export const siteAuditDashboardBlank = {
  previousScanLabel: {
    fontWeight: 900,
    fontSize: 'var(--font-size-18)',
    fontFamily: 'Inter',
    color: 'var(--color-text-heading)'
  },
  siteAuditButtonSx: {
    pt: 0,
    pb: 0,
    fontSize: {
      xs: '10px',
      sm: '14px',
      md: '14px',
      lg: '14px'
    },
    height: { sm: '60px', md: '40px', lg: '40px' },
    ml: 1
  },
  siteAuditAddSx: {
    color: 'var(--color-text-grey-purple)',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    textAlign: 'center'
  }
};

export const siteAuditModalSx = {
  siteAuditModalDescription: {
    fontWeight: 400,
    fontSize: '13px',
    lineHeight: 'var(--line-height-20)',
    letterSpacing: 0,
    fontFamily: 'Inter',
    color: 'var(--color-black)'
  },
  infoIconSx: {
    color: 'var(--color-teal)',
    fontSize: 'var(--font-size-20)',
    marginLeft: '10px'
  },
  alertDescription: {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    color: 'rgba(0, 0, 0, 0.4)',
    borderRadius: '4px',
    padding: '0px',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: '11px',
    fontWeight: '400 !important',
    lineHeight: 'var(--line-height-18)',
    letterSpacing: '0px',
    textAlign: 'left'
  },
  lorem: {
    fontWeight: 300,
    fontSize: 'var(--font-size-14)',
    lineHeight: '21px',
    letterSpacing: 0,
    fontFamily: 'Inter',
    color: 'var(--color-black)'
  },
  googleSearchConsole: {
    width: '100%',
    height: '48px',
    borderRadius: '5px',
    gap: '4px',
    marginTop: '3%'
  },
  updateGSCText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    margin: '0px 0 0 0',
    color: 'var(--color-text-grey2)'
  },
  makeSureConnectedToGoogleConsole: {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    color: 'rgba(0, 0, 0, 0.4)',
    borderRadius: '4px',
    padding: '0px',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '400 !important',
    lineHeight: 'var(--line-height-18)',
    letterSpacing: '0px',
    textAlign: 'left'
  },
  howToConnectGsc: {
    width: '120px',
    height: '12px',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '500 !important',
    lineHeight: '12px',
    letterSpacing: '0.20000000298023224px',
    textAlign: 'right',
    textDecoration: 'underline'
  },
  secondBoxSx: {
    padding: 1,
    width: 'auto',
    backgroundColor: 'var(--color-bg-off-white)',
    borderRadius: 1
  },
  step: {
    '& .MuiStepLabel-root .Mui-completed': {
      color: 'var(--color-secondary)'
    },
    '& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel': {
      color: 'var(--color-secondary)'
    },
    '& .MuiStepLabel-root .Mui-active': {
      color: 'var(--color-primary)'
    },
    '& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel': {
      color: 'common.white'
    },
    '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
      fill: 'common.white'
    }
  },
  stepLabel: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 0,
    fontSize: '10px',
    lineHeight: '1.5'
  },
  guideText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 0,
    fontSize: 'var(--font-size-16)',
    color: 'black',
    lineHeight: '1.5'
  },
  watchVideoTextSx: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: 'var(--color-primary)',
    fontWeight: 500
  }
};

export const siteAuditOopsPageSx = {
  websiteAudit: {
    fontWeight: 900,
    fontSize: 'var(--font-size-18)',
    fontFamily: 'Inter',
    color: 'var(--color-text-heading)'
  },
  oopsSx: {
    width: '65px',
    height: '36px',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: '800 !important',
    lineHeight: 'var(--line-height-36)',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'var(--color-text-heading)'
  },
  noWebsiteScanned: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: '400 !important',
    lineHeight: 'var(--line-height-24)',
    letterSpacing: '0.20000000298023224px',
    textAlign: 'left'
  },
  scanWebpage: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: '700 !important',
    lineHeight: 'var(--line-height-22)',
    letterSpacing: '0em',
    textAlign: 'left'
  }
};

export const siteAuditProgressSx = {
  mainBoxSx: {
    display: 'block',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    paddingLeft: '0px !important',
    paddingRight: '0px !important'
  },
  secondBoxSx: {
    width: '100%', // Adjusted to match Card's dimensions
    height: 'calc(100% - 32px)', // Adjusted to match Card's dimensions
    backgroundColor: 'var(--color-white)', // White background color
    borderRadius: '12px',
    boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.08)' // Optional box shadow
  },
  card: {
    width: '100%',
    height: '100%',
    overflow: 'hidden', // Hide any potential overflow
    padding: 0
  },
  webSiteAudit: {
    fontFamily: 'Inter',
    fontSize: { xs: '16px', sm: '18px' },
    fontWeight: 800,
    lineHeight: '27px',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'var(--color-text-heading)'
  },
  yourWebsiteAudit: {
    fontFamily: 'Inter',
    fontSize: { xs: '14px', sm: '16px' },
    fontWeight: 500,
    lineHeight: '34px',
    letterSpacing: '0em',
    textAlign: 'center'
  },
  secondMainBox: {
    width: '100%',
    height: 'auto',
    gap: '0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingX: { xs: '20px', sm: '0px' },
    paddingTop: '50px',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  alertSx: {
    backgroundColor: 'rgba(248, 248, 248, 1);',
    color: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '4px',
    width: '100%',
    maxWidth: '736px',
    padding: '0'
  },
  noteBoxSx: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '700 !important',
    lineHeight: 'var(--line-height-18)',
    letterSpacing: '0.20000000298023224px',
    color: 'var(--color-black)',
    paddingRight: '10px'
  },
  auditTakes: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '400 !important',
    lineHeight: 'var(--line-height-18)',
    letterSpacing: '0px',
    color: 'var(--color-black)',
    display: 'contents'
  },
  uptominutes: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '700 !important',
    lineHeight: 'var(--line-height-18)',
    letterSpacing: '0px',
    color: 'var(--color-black)',
    display: 'contents'
  },
  notifyOnComplete: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '400 !important',
    lineHeight: 'var(--line-height-18)',
    letterSpacing: '0px',
    color: 'var(--color-black)',
    display: 'contents'
  },
  seeResults: {
    pt: 0,
    pb: 0,
    fontSize: { xs: '12px', sm: '14px' },
    marginTop: { xs: '30px', sm: '50px' },
    ml: 1,
    width: '284px',
    height: '49px'
  },
  thirdMainBoxSx: {
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '24px',
    marginTop: '50px',
    borderRadius: '12px',
    backgroundColor: 'rgba(232, 241, 253, 1)'
  },
  videoDescription: {
    color: 'var(--color-black)',
    font: 'Raleway',
    fontWeight: '400 !important',
    fontSize: 'var(--font-size-16)',
    lineHeight: 'var(--line-height-24)',
    letterSpacing: '0.2px'
  },
  reloadPageStyle: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '400 !important',
    lineHeight: 'var(--line-height-18)',
    letterSpacing: '0px',
    color: 'var(--color-error-light)',
    display: 'contents'
  },
  finalStagePageStyle: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: '400 !important',
    lineHeight: 'var(--line-height-18)',
    letterSpacing: '0px',
    color: 'var(--color-error-light)',
    display: 'contents',
    marginBottom: '8px'
  },
  stuckPageStyle: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: '400 !important',
    lineHeight: 'var(--line-height-18)',
    letterSpacing: '0px',
    color: 'var(--color-error-light)',
    display: 'contents',
    mb: 1
  },

  pageMsgBox: {
    display: 'flex'
  },
  siteProgressLoadingBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    mt: 2
  },
  siteProgressLoadingSubBox: {
    display: 'flex',
    alignItems: 'center'
  },
  siteProgressLoadingText: {
    fontFamily: 'Inter',
    fontSize: { xs: '14px', sm: '19px' },
    fontWeight: 600,
    lineHeight: '34px',
    letterSpacing: '0em',
    textAlign: 'center',
    color: 'rgba(17, 20, 45, 0.52)',
    ml: 1
  },
  loadingGif: {
    width: 30,
    height: 30
  },
  newProgressBoxSx: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    paddingLeft: '20px',
    paddingRight: '20px'
  },
  newPagesTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-14)',
    textAlign: 'center',
    color: 'var(--color-text-input)',
    minWidth: 'max-content'
  },
  progressTextSx: {
    //styleName: Text md/Regular;
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left'
  },
  progressTextBoxSx: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '16px',
    marginTop: '30px'
  },
  percentageTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-dark)',
    paddingLeft: '20px'
  },
  newBtnBoxSx: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '40px'
  },
  newBtnSx: {
    padding: '10px 32px 10px 32px',
    gap: '6px',
    borderRadius: '6px'
  },
  siteAuditSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-32)',
    textAlign: 'left',
    color: 'var(--color-primary)',
    marginBottom: '21px'
  }
};

export const websiteAuditDashboardSx = {
  styledTableCell: {
    width: '100%',
    height: '14px',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: 'var(--line-height-14)',
    letterSpacing: '0em',
    textAlign: 'left',
    color: 'var(--color-text-grey-purple)'
  }
};

export const downloadPluginModalSxs = {
  mainBox: {
    paddingBottom: '18px'
  },
  headingText: {
    fontSize: 'var(--font-size-14)',
    fontWeight: 200
  },
  desc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-22)',
    textAlign: 'left',
    marginTop: '0.5rem'
  },
  btnBox: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'end',
    mt: 2
  }
};

export const SkipSiteAuditModalSx = {
  mainBox: {
    padding: '0px 14px 32px 14px'
  },
  skipModalDesc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left'
  },
  btnBox: {
    mt: 4,
    display: 'flex',
    gap: '12px'
  }
};

export const siteProgressSecondBoxSx = {
  watchTutorialBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '3px',
    cursor: 'pointer',
    justifyContent: 'center',
    marginTop: {
      ns: '-5px !important',
      sm: '-25px !important',
      md: '-50px !important'
    },
    marginBottom: '30px'
  },
  watchTutorialText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  imgSx: {
    marginTop: '2.5px'
  }
};

export const siteAuditDashboardNewBlankSx = {
  titleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-32)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  titleBoxSx: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  addYourSiteSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-text-heading)'
  },
  descSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-mid)',
    marginTop: '10px'
  },
  textsBoxSx: {
    width: '32rem',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  btnSx: {
    padding: '10px 18px 10px 18px',
    gap: '6px',
    borderRadius: '6px'
  },
  watchTutorialBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    cursor: 'pointer',
    justifyContent: 'center',
    marginTop: {
      ns: '-3px !important',
      sm: '-0px !important',
      md: '-25px !important'
    },
    marginBottom: '30px'
  }
};

export const deleteMultipleRowSx = {
  deleteMultipleBox: {
    display: 'flex',
    gap: 1
  },
  deleteBtn: {
    fontWeight: 500,
    borderRadius: '6px',
    pt: 0,
    pb: 0,
    fontSize: {
      xs: '10px',
      sm: '14px',
      md: '14px',
      lg: '14px'
    },
    height: { sm: '60px', md: '40px', lg: '40px' }
  },
  cancelSx: {
    fontWeight: 500,
    borderRadius: '6px',
    pt: 0,
    pb: 0,
    fontSize: {
      xs: '10px',
      sm: '14px',
      md: '14px',
      lg: '14px'
    },
    height: { sm: '60px', md: '40px', lg: '40px' }
  },
  dialogBox: {
    padding: '20px',
    width: '400px'
  },
  dialogSubBox: {
    textAlign: 'center',
    position: 'relative'
  },
  deleteScan: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: 'var(--font-size-20)',
    lineHeight: 'var(--line-height-30)',
    letterSpacing: '0%',
    color: 'var(--color-primary)'
  },
  deleteScanSpan: {
    position: 'absolute',
    right: '0px',
    top: '-3px'
  },
  iconButtonSx: {
    height: '40px',
    padding: '8px',
    paddingRight: '5px'
  },
  descBoxSx: {
    textAlign: 'center',
    marginTop: '20px'
  },
  descSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    letterSpacing: '0%',
    color: 'var(--color-text-secondary)'
  },
  btnBoxSx: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
    gap: '10px'
  },
  cancelBtnSx: {
    padding: '10px 18px',
    fontWeight: 500,
    borderRadius: '6px'
  }
};
